const LIFETIME_PRO_EMAILS = new Set(['benkhemis.akram@gmail.com']);

export function normalizeBillingEmail(
  email: string | null | undefined,
): string {
  return (email ?? '').trim().toLowerCase();
}

export function hasLifetimeProPlan(email: string | null | undefined): boolean {
  return LIFETIME_PRO_EMAILS.has(normalizeBillingEmail(email));
}
